<template>
  <div>
    <!-- Barra informativa solo para no logueados -->
    <div v-if="!esUsuario" class="w-full" style="background:#d3d3d9;">
      <div class="max-w-6xl mx-auto flex items-center justify-between py-4 px-4 flex-wrap gap-4 ">
        <span class="text-xs md:text-sm text-black font-semibold">¿Tenés tareas pendientes? Iniciá sesión para ver tus talleres</span>
        <router-link to="/ingresar">
          <button class="bg-[#366aff] hover:bg-blue-700 text-white text-xs px-3 py-1 rounded font-semibold" style="box-shadow:none; min-width:90px;">Iniciar sesión</button>
        </router-link>
      </div>
    </div>
    <!-- <div v-if="esUsuario" class="w-full" style="background:#d3d3d9;">
      <div class="max-w-6xl mx-auto flex items-center justify-between py-4 px-4">
        <span class="text-xs md:text-sm text-black font-semibold">Todos los cursos</span>
        <button
          @click="cerrarSesion"
          class="bg-[#366aff] hover:bg-blue-700 text-white text-xs px-3 py-1 rounded font-semibold"
          style="box-shadow:none; min-width:90px;">
          Cerrar sesión
        </button>
      </div>
    </div> -->
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useAuthStore } from "@/stores/auth";

const store = useAuthStore();
const esUsuario = computed(() => !!store.usuario);

const cerrarSesion = () => {
  store.cerrarSesion();
};
</script> 